// orderSource — where an order came from. Manual orders (placed by staff in the
// ERP) must be tagged with one of the MANUAL_SOURCES below. Orders created by
// an automated channel (website, storefront checkout, WhatsApp parser, a
// customer's own profile) keep their own auto source and are never prompted.

// The three manual sources staff pick when placing an order by hand.
export const MANUAL_SOURCES = [
    { value: 'incoming_call', label: 'Incoming Call' },
    { value: 'tele_sales', label: 'Tele Sales' },
    { value: 'feedback_order', label: 'Feedback Order' },
];

export const MANUAL_SOURCE_VALUES = MANUAL_SOURCES.map((s) => s.value);

// Human labels for every source we display anywhere (manual + auto).
const SOURCE_LABELS = {
    incoming_call: 'Incoming Call',
    tele_sales: 'Tele Sales',
    feedback_order: 'Feedback Order',
    website: 'Website',
    storefront: 'Storefront',
    'storefront-admin': 'Storefront (Admin)',
    parser: 'WhatsApp Parser',
    whatsapp: 'WhatsApp',
    customer_profile: 'Customer Profile',
    bulk_import: 'Bulk Import',
    'Bulk Import': 'Bulk Import',
    orderlist: 'Order List',
};

/** A readable label for any source value (falls back to a tidied raw value). */
export const sourceLabel = (value) => {
    if (!value) return 'Unknown';
    if (SOURCE_LABELS[value]) return SOURCE_LABELS[value];
    return String(value)
        .replace(/[_-]+/g, ' ')
        .replace(/\b\w/g, (c) => c.toUpperCase());
};

/** True when the source is one of the three manual (staff-placed) sources. */
export const isManualSource = (value) => MANUAL_SOURCE_VALUES.includes(value);
